// 사용자 홈 컴포넌트

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역
import React, { // 리액트 베이스
  useEffect, // 상태 변경 이벤트 헨들러
  useState, // 내부 상태 관리 훅
  useRef, // 객체 참조자
  forwardRef,
  Fragment, // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
  useCallback, // 상태 변경시까지 함수 재사용 장치 // 재사용 가능한 라이브러리 컴포넌트에서, 자식 중 하나에 ref를 전달
} from 'react';
import M from 'src/com/keymansco/chihuahuaone/helper/mainHelper'; // 메인 헬퍼
import atom from 'src/com/keymansco/chihuahuaone/atom/index'; // 원자 컴포넌트
import molecule from 'src/com/keymansco/chihuahuaone/molecule/index'; // 분자 컴포넌트
import organism from 'src/com/keymansco/chihuahuaone/organism/index'; // 업무 컴포넌트
import template from 'src/com/keymansco/chihuahuaone/template/index'; // 템플릿 컴포넌트
import page from 'src/com/keymansco/chihuahuaone/page/index'; // 페이지 컴포넌트

// 동적 영역
import UserHomeModel from './UserHomeModel'; // 모델
import catFaceDrawImage from 'src/../assets/molecule/animation/ShowNHide/cat_face_draw.png';
import {
  Asset,
  useAssets, // (비동기) 파일 에셋 온메모리 로드 [앱 실행중 동적 변경 불가]
} from 'expo-asset';
import MobileStoreButton from 'react-mobile-store-button';

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 컴포넌트 정의
// =================================================================================================
const UserHome = forwardRef((props, ref) => {
  let P = UserHomeModel; // P 자동완성용
  P = props; // 속성. 읽기전용.

  // 내부 상태 [컴포넌트 자체 뷰 갱신 전용. private.]
  const [petName, setPetName] = useState('');

  // 자산 목록
  const [assetList, assetListError] = useAssets(
    // (비동기) 파일 에셋 온메모리 로드
    [
      require('src/../assets/page/common/UserHome/playstore_catchphrase_1024x500.jpeg'), // [require는 코드 중간에 사용 가능. 단, 인자로 변수 활용 불가.]
      require('src/../assets/page/common/UserHome/6.5-inch Screenshot 1.jpeg'), //
      require('src/../assets/page/common/UserHome/6.5-inch Screenshot 2.jpeg'), //
      require('src/../assets/page/common/UserHome/6.5-inch Screenshot 3.jpeg'), //
      require('src/../assets/page/common/UserHome/6.5-inch Screenshot 4.jpeg'), //
      require('src/../assets/page/common/Intro/app_icon.png'), //
    ],
  );
  const [assetMap, setAssetMap] = useState({});

  // 외부 상태 [외부 개방용. public.]

  // 참조 변수
  const facebookMessengerChatRef = useRef(null); // 페이스북 메신저 채팅 참조

  // 상수

  // =================================================================================================
  // 컨테이너 컴포넌트 이벤트 핸들러
  // =================================================================================================
  // 컴포넌트 미운트 시 [componentDidMount, componentDidUpdate] [인자값 변경시 동작] [빈 배열 적용시 최초 마운트 때 한번 동작]
  useEffect(() => {
    M.log.info('UserHome');

    // 컴포넌트 언마운트 시(componentWillUnmount)
    return () => {};
  }, []);

  useEffect(() => {
    if (assetList) {
    } else {
      return;
    }

    let assetMap1 = {};
    let itemIndex = 0;
    assetMap1['src/../assets/page/common/UserHome/playstore_catchphrase_1024x500.jpeg'] = assetList[itemIndex];
    itemIndex++;
    assetMap1['src/../assets/page/common/UserHome/6.5-inch Screenshot 1.jpeg'] = assetList[itemIndex];
    itemIndex++;
    assetMap1['src/../assets/page/common/UserHome/6.5-inch Screenshot 2.jpeg'] = assetList[itemIndex];
    itemIndex++;
    assetMap1['src/../assets/page/common/UserHome/6.5-inch Screenshot 3.jpeg'] = assetList[itemIndex];
    itemIndex++;
    assetMap1['src/../assets/page/common/UserHome/6.5-inch Screenshot 4.jpeg'] = assetList[itemIndex];
    itemIndex++;
    assetMap1['src/../assets/page/common/Intro/app_icon.png'] = assetList[itemIndex];
    itemIndex++;

    setAssetMap(assetMap1);
  }, [assetList]); // 자산 목록 로드시

  useEffect(() => {
    if (facebookMessengerChatRef.current) {
    } else {
      return;
    }

    // let chatbox = document.getElementById('fb-customer-chat');
    facebookMessengerChatRef.current.setAttribute('page_id', '100200146171650');
    facebookMessengerChatRef.current.setAttribute('attribution', 'biz_inbox');

    window.fbAsyncInit = function () {
      FB.init({
        xfbml: true,
        version: 'v14.0',
      });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }, [facebookMessengerChatRef.current]); // ... 변경시

  // =================================================================================================
  // 컴포넌트 함수 정의
  // =================================================================================================

  // =================================================================================================
  // 그리기
  // =================================================================================================
  // 렌더링(render)
  return (
    <atom.layout.ZStack // Z축 쌓기
      type={'centerTop'} // 타입 {undefined: 미정의, centerTop: 중앙상단+풀, centerFull: 중앙+풀}
    >
      {/* <atom.layout.VStack // 행 쌓기
        type={'bgBasicCenterFull'} // 타입 {undefined: 미정의, bgBasicCenterFull: 배경+중앙+풀, centerFull: 중앙+풀, bottomCenter: 하단+중앙}
      ></atom.layout.VStack> */}

      <atom.layout.VStack // 행 쌓기
        type={'topCenter'} // 타입 {undefined: 미정의, bgBasicCenterFull: 배경+중앙+풀, centerFull: 중앙+풀, bottomCenter: 하단+중앙, topCenter: 상단+중앙}
        width={M.style.width.screen}
        {...M.style.bg.basic}
        // 주입 속성
        {...P}
        ref={ref}
        style={{
          // 인라인 스타일 [스타일 분리시, 모양새 추정에 불리.]
          ...P.style,
        }}
      >
        {assetList == undefined ? (
          <atom.feedback.Spinner // 회전자
          />
        ) : (
          <Fragment>
            <atom.layout.VStack // 행 쌓기
              type={'topCenter'} // 타입 {undefined: 미정의, bgBasicCenterFull: 배경+중앙+풀, centerFull: 중앙+풀, bottomCenter: 하단+중앙, topCenter: 상단+중앙}
              isScrollable={false} // 스크롤 가능 여부
            >
              <atom.media.Image // 이미지 [버튼 내부에 이미지 삽입시, 사이즈 지정 필수]
                height={M.style.height.big} // height [h]
                source={assetMap['src/../assets/page/common/UserHome/playstore_catchphrase_1024x500.jpeg']}
                type={undefined} // 타입 {undefined: 미정의, basic: 기본}
                width={M.theme.sizes.full} // width [w] [nPx, fit-content, ...]
                resizeMode={'cover'} // {center: 중앙. 기본., cover: 공간 안비게. 비율 유지., contain: 그림 안잘리게. 비율 유지., stretch: 채우기. 비율 변경., repeat: 반복}
              />
            </atom.layout.VStack>

            <atom.layout.VStack // 행 쌓기
              type={'topCenter'} // 타입 {undefined: 미정의, bgBasicCenterFull: 배경+중앙+풀, centerFull: 중앙+풀, bottomCenter: 하단+중앙, topCenter: 상단+중앙}
              isScrollable={false} // 스크롤 가능 여부
            >
              <atom.layout.HStack // 열 쌓기
                isReverse={false} // 역방향 여부
                type={'full'} // 타입 {undefined: 미정의, full: 풀, center: 중앙}
              >
                <atom.media.Image // 이미지 [버튼 내부에 이미지 삽입시, 사이즈 지정 필수]
                  height={M.theme.sizes[4]} // height [h]
                  source={assetMap['src/../assets/page/common/Intro/app_icon.png']}
                  type={'basic'} // 타입 {undefined: 미정의, basic: 기본}
                  width={M.theme.sizes[4]} // width [w] [nPx, fit-content, ...]
                  resizeMode={'cover'} // {center: 중앙. 기본., cover: 공간 안비게. 비율 유지., contain: 그림 안잘리게. 비율 유지., stretch: 채우기. 비율 변경., repeat: 반복}
                  top={M.theme.space[1]} // left [space]
                  left={M.theme.space[1]} // left [space]
                />

                <atom.typograpgy.Text // 텍스트
                  type={'title'} // 타입 {undefined: 미정의, basic: 기본, title: 제목, big: 큰}
                >
                  Pet-T App
                </atom.typograpgy.Text>
              </atom.layout.HStack>
              <atom.layout.HStack // 열 쌓기
                isReverse={false} // 역방향 여부
                type={'center'} // 타입 {undefined: 미정의, full: 풀, center: 중앙}
              >
                <atom.media.Image // 이미지 [버튼 내부에 이미지 삽입시, 사이즈 지정 필수]
                  height={M.theme.sizes[24]} // height [h]
                  source={assetMap['src/../assets/page/common/UserHome/6.5-inch Screenshot 1.jpeg']}
                  type={'basic'} // 타입 {undefined: 미정의, basic: 기본}
                  width={M.theme.sizes[12]} // width [w] [nPx, fit-content, ...]
                  resizeMode={'contain'} // {center: 중앙. 기본., cover: 공간 안비게. 비율 유지., contain: 그림 안잘리게. 비율 유지., stretch: 채우기. 비율 변경., repeat: 반복}
                />

                <atom.media.Image // 이미지 [버튼 내부에 이미지 삽입시, 사이즈 지정 필수]
                  height={M.theme.sizes[24]} // height [h]
                  source={assetMap['src/../assets/page/common/UserHome/6.5-inch Screenshot 2.jpeg']}
                  type={'basic'} // 타입 {undefined: 미정의, basic: 기본}
                  width={M.theme.sizes[12]} // width [w] [nPx, fit-content, ...]
                  resizeMode={'contain'} // {center: 중앙. 기본., cover: 공간 안비게. 비율 유지., contain: 그림 안잘리게. 비율 유지., stretch: 채우기. 비율 변경., repeat: 반복}
                />
              </atom.layout.HStack>
              <atom.layout.HStack // 열 쌓기
                isReverse={false} // 역방향 여부
                type={'center'} // 타입 {undefined: 미정의, full: 풀, center: 중앙}
                marginTop={M.theme.space[1]} // margin-top [mt] [space]
              >
                <atom.media.Image // 이미지 [버튼 내부에 이미지 삽입시, 사이즈 지정 필수]
                  height={M.theme.sizes[24]} // height [h]
                  source={assetMap['src/../assets/page/common/UserHome/6.5-inch Screenshot 3.jpeg']}
                  type={'basic'} // 타입 {undefined: 미정의, basic: 기본}
                  width={M.theme.sizes[12]} // width [w] [nPx, fit-content, ...]
                  resizeMode={'contain'} // {center: 중앙. 기본., cover: 공간 안비게. 비율 유지., contain: 그림 안잘리게. 비율 유지., stretch: 채우기. 비율 변경., repeat: 반복}
                />

                <atom.media.Image // 이미지 [버튼 내부에 이미지 삽입시, 사이즈 지정 필수]
                  height={M.theme.sizes[24]} // height [h]
                  source={assetMap['src/../assets/page/common/UserHome/6.5-inch Screenshot 4.jpeg']}
                  type={'basic'} // 타입 {undefined: 미정의, basic: 기본}
                  width={M.theme.sizes[12]} // width [w] [nPx, fit-content, ...]
                  resizeMode={'contain'} // {center: 중앙. 기본., cover: 공간 안비게. 비율 유지., contain: 그림 안잘리게. 비율 유지., stretch: 채우기. 비율 변경., repeat: 반복}
                />
              </atom.layout.HStack>

              <atom.layout.VStack // 행 쌓기
                type={'topCenter'} // 타입 {undefined: 미정의, bgBasicCenterFull: 배경+중앙+풀, centerFull: 중앙+풀, bottomCenter: 하단+중앙, topCenter: 상단+중앙}
                isScrollable={false} // 스크롤 가능 여부
                marginTop={M.theme.space[4]} // margin-top [mt] [space]
              >
                <MobileStoreButton store="ios" url={'https://apps.apple.com/app/id1641865374'} linkProps={{ title: 'Download on the App Store' }} height={60} width={204} />

                <MobileStoreButton
                  store="android"
                  url={'https://play.google.com/store/apps/details?id=com.keymansco.pett3'}
                  linkProps={{ title: 'Get it on Google Play' }}
                  height={160}
                  width={234}
                  linkStyles={{
                    marginTop: '36px',
                  }}
                />
              </atom.layout.VStack>

              <atom.form.Button // 버튼
                type={'basic'} // 타입 {undefined: 미정의, basic: 기본, image: 이미지, circle: 원, icon: 아이콘}
                onPress={() => {
                  window.open('mailto:chiconkeyco@gmail.com');
                }}
              >
                <atom.typograpgy.Text // 텍스트
                  type={'basic'} // 타입 {undefined: 미정의, basic: 기본, title: 제목, big: 큰}
                >
                  Send E-Mail
                </atom.typograpgy.Text>
              </atom.form.Button>
            </atom.layout.VStack>
          </Fragment>
        )}
      </atom.layout.VStack>

      <molecule.animation.ShowNHide // 보이고 숨기
        alignSelf={'flex-end'}
        height={800 * 0.4} //
        rotate={120 / 360} //
        width={960 * 0.4} //
      >
        <atom.media.Image // 이미지 [버튼 내부에 이미지 삽입시, 사이즈 지정 필수]
          height={M.theme.sizes[20]} // height [h]
          source={catFaceDrawImage} // 이름
          type={'basic'} // 타입 {undefined: 미정의, basic: 기본}
          width={M.theme.sizes[24]} // width [w] [nPx, fit-content, ...]
        />
      </molecule.animation.ShowNHide>

      {/* <!-- Messenger 채팅 플러그인 Code --> */}
      {/* [https://www.youtube.com/watch?v=zw4CvM4vX2c&list=PLDLOX_aRgZSD8mCf2wLJ8S3jibczErzqf] */}
      <div id="fb-root"></div>

      {/* <!-- Your 채팅 플러그인 code --> */}
      <div id="fb-customer-chat" className="fb-customerchat" ref={facebookMessengerChatRef}></div>

      {M.const.isDevMode() && (
        <atom.typograpgy.Text // 텍스트
          type={'basic'} // 타입 {undefined: 미정의, basic: 기본, title: 제목, big: 큰}
          // marginTop={M.theme.space[2]} // margin-top [mt] [space]
          color={M.theme.colors.white} // color
        >
          개발모드
        </atom.typograpgy.Text>
      )}
    </atom.layout.ZStack>
  );
});

// =================================================================================================
// 내보내기
// =================================================================================================
export default UserHome;
